import Reflection from '../../reflection';
import Type from '../../type';
import extensionsStorage from './internal/extensions-storage';
import { processExtensions } from './internal/process-extensions';
import { registerFromDocument } from './internal/register-extension';

export type ExtensionExports = { [key: string]: any };
export type LoadExtensionResult = Promise<Array<ExtensionExports>>;
export type LoadableExtensionEntry = {
	promise: Promise<any>;
	resolve: any;
	reject: any;
};

const queue: Map<string, LoadableExtensionEntry> = new Map();
let timerId: any = null;

export default async function loadExtension(...name: Array<string | Array<string>>): LoadExtensionResult
{
	if (Type.isNumber(timerId))
	{
		clearTimeout(timerId);
	}

	registerFromDocument();

	const requestedNames: Array<string> = name.flat();
	const extensionsToLoad: Array<string> = requestedNames.filter((extensionName: string) => {
		return !extensionsStorage.has(extensionName);
	});

	extensionsToLoad.forEach((extensionName: string) => {
		let resolve: any = null;
		let rejectPromise: any = null;
		// eslint-disable-next-line promise/param-names
		const promise: Promise<any> = new Promise((sourceResolve, sourceReject) => {
			resolve = sourceResolve;
			rejectPromise = sourceReject;
		});

		// A failed load must not stay in the storage: the name would be filtered out
		// above and every later call would get the same rejected promise, with no
		// request, until the page reloads. Callers already waiting share this promise
		// and still receive the error.
		const reject = (error: any): void => {
			if (extensionsStorage.get(extensionName) === promise)
			{
				extensionsStorage.delete(extensionName);
			}

			rejectPromise(error);
		};

		const loadableExtensionEntry: LoadableExtensionEntry = { promise, resolve, reject };

		extensionsStorage.set(extensionName, loadableExtensionEntry.promise);
		queue.set(extensionName, loadableExtensionEntry);
	});

	timerId = setTimeout(() => {
		if (queue.size > 0)
		{
			void processExtensions(new Map(queue.entries()));
			queue.clear();
		}
	});

	const namespaces: Array<any> = await Promise.all(
		requestedNames.map((extensionName: string) => {
			return extensionsStorage.get(extensionName);
		}),
	);

	return namespaces.reduce((acc: any, namespace: string) => {
		return { ...acc, ...Reflection.getClass(namespace) };
	}, {});
}
